import type { Conversation } from "@/pages/Private/pages/Apollo/schema/get-people";

const SENT_TYPES = ["mail_sent", "message_sent"];

/**
 * Who sent (or, for an inbound message, received) a conversation: its `user`, or its bare
 * `userId` where the endpoint serves no user object (the list table's leads). Every sender
 * decision reads it here, so a colleague's thread matches the same way on every surface
 * (PREC-4312).
 */
export const conversationSenderUserId = (
	conversation: Pick<Conversation, "user" | "userId">
): number | undefined => conversation.user?.id ?? conversation.userId ?? undefined;

/** The user who sent the lead's latest message, or undefined when none of ours sent one. */
export const resolveLastSenderUserId = (
	conversations: Conversation[] | null | undefined
): number | undefined =>
	[...(conversations ?? [])]
		.filter((c) => SENT_TYPES.includes(c.type) && conversationSenderUserId(c))
		.sort((a, b) => new Date(b.sentAt).getTime() - new Date(a.sentAt).getTime())
		.map(conversationSenderUserId)[0];

/**
 * Whether that sender is connected to the lead on LinkedIn; undefined without a last sender. Was
 * written out twice, in `useAddInboxChat` and `useProspectLinkedinConnections`.
 */
export const isLastSenderConnectedTo = (
	lastSenderUserId: number | undefined,
	connectedUserIds: Set<number>
): boolean | undefined => (lastSenderUserId ? connectedUserIds.has(lastSenderUserId) : undefined);
